module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/animated-buttons/animated-buttons.component.scss
// module id = ./src/app/features/buttons/animated-buttons/animated-buttons.component.scss
// module chunks = main